import { Icon } from '@tcweb/connect-ui';
import { Component, Show } from 'solid-js';
import { ActionMenuItem } from './types';

interface ControlMenuActionRowProps {
  item: ActionMenuItem;
}

export const ControlMenuActionRow: Component<ControlMenuActionRowProps> = (
  props
) => (
  <div
    class="flex items-center gap-2 w-full"
    data-testid={'control-menu-dropdown-option-' + props.item.id}
    aria-selected={props.item.selected ?? false}
  >
    <Show when={props.item.icon}>
      <Show
        when={typeof props.item.icon === 'string'}
        fallback={props.item.icon}
      >
        <Icon
          icon={props.item.icon as string}
          class="flex min-w-5 min-h-5 text-base-content"
        />
      </Show>
    </Show>
    <span class="whitespace-nowrap text-base-content">{props.item.label}</span>
  </div>
);
